<template>
  <div class="l-flex volume-box">
    <div :style="{ background: chartColors[volumeKey], marginRight: '5px', borderRadius: '50px' }">
      <svg-icon :name="icon" class="icon-volume" :size="['app-volume', 'crm-id'].includes(icon) ? 'small' : 'medium'" />
    </div>
    <div>
      <div class="volume-box-label l-flex-row--rev">
        {{ label }}
      </div>
      <div v-if="isLoading" class="volume-box-value">
        <spinner width="20" height="20" />
      </div>
      <div v-else class="volume-box-value">
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { VOLUME_CHART_COLORS } from '@/utils/constants'

export default {
    name: 'Volume',

    props: {
        label: {
            type: String,
            required: true
        },

        value: {
            type: String,
            required: true
        },

        icon: {
            type: String,
            required: true
        },

        parent: {
            type: String,
            default: ''
        },

        img: {
            type: Boolean,
            default: false
        },

        volumeKey: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            chartColors: VOLUME_CHART_COLORS,
        }
    },

    computed: {
        ...mapState('builder', {
            formulaVolumesLoading: state => state.formulaVolumesLoading
        }),

        ...mapState('ui/builder', {
            legacyLoading: state => state.isLoading.volumes
        }),

        isLoading() {
            return this.parent === 'builder' ? this.formulaVolumesLoading : this.legacyLoading
        }
    }
}
</script>
<style lang="scss" scoped>
.img-volume {
    width: 30px;
    height: 35px;
}
</style>
